<template>
  <div class="order-list-wrapper">
    <div class="list-container" v-if="dataDone && orderList.length > 0">
      <router-link tag="div" :to="{path: '/patient/order/detail', query: {order_id: item.order_id}}" class="order-item" v-for="item in orderList" :key="item.order_id">
        <div class="order-header">
          <div class="order-date">{{item.create_time | dateFilter}}</div>
          <div class="order-status unpaid" v-if="item.status == 1">待支付<icon icon-class="arrow"></icon></div>
          <div class="order-status invalid" v-if="item.status == 2">失效</div>
          <div class="order-status payed" v-if="item.status == 3">已支付<icon icon-class="arrow"></icon></div>
          <div class="order-status payed" v-if="item.status == 4">已完成<icon icon-class="arrow"></icon></div>
          <div class="order-status normal" v-if="item.status == -1">退款中</div>
          <div class="order-status normal" v-if="item.status == -2">已退款</div>
        </div>
        <div class="order-content" :class="{'no-bottom': item.status != 1}">
          <div class="order-title">
            <div class="title">{{item.title}}</div>
            <div class="order-price">¥ {{item.money | int}}<span>{{item.money | float}}</span></div>
          </div>
          <div class="order-info">
            <div class="order-doc-info">
              <div class="content-item">
                <div class="type">医生</div>
                <div class="info-content">{{item.username}}</div>
              </div>
              <div class="content-item">
                <div class="type">科室</div>
                <div class="info-content">{{item.p_dep_title}} - {{item.dep_title}}</div>
              </div>
            </div>

          </div>
          <div class="unpaid" v-if="item.status == 1">
            <div class="unit-time">剩余支付时间为<van-count-down class="countdown" :time="item.leftTime" /></div>
            <button class="pay-button">去支付</button>
          </div>
        </div>
      </router-link>
      <div class="data-loading" v-if="dataDone && !isOver"><van-loading type="spinner" size="14px">加载中...</van-loading></div>
      <div class="data-finish" v-if="dataDone && isOver">无更多数据</div>
    </div>
    <div class="empty-data" v-if="dataDone && orderList.length == 0">
      <icon icon-class="empty-order"></icon>
      <p>暂无订单记录</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .order-list-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 12px;
    .order-item{
      padding: 0 20px;
      background: #FFF;
      margin-bottom: 8px;
      .order-header{
        height: 50px;
        border-bottom: 1px solid #EEE;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .order-date{
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
        .order-status{
          font-size: 15px;
          line-height: 15px;
          font-weight: bold;
          svg{
            font-size: 15px;
            margin-left: 4px;
          }
          &.unpaid{
            color: @error;
            svg{
              color: @error;
            }
          }
          &.payed{
            color: @xile;
            svg{
              color: @xile;
            }
          }
          &.normal{
            color: #666;
            svg{
              display: none;
            }
          }
          &.invalid{
            color: #999;
            svg{
              display: none;
            }
          }
        }
      }
      .order-content{
        padding-top: 16px;
        &.no-bottom{
          padding-bottom: 24px;
        }
        .order-title{
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: @black;
          font-weight: bold;
          .title{
            font-size: 15px;
            line-height: 15px;
          }
          .order-price{
            font-size: 18px;
            line-height: 18px;
            font-weight: bold;
            color: #666;
            span{
              font-size: 12px;
            }
          }
        }
        .order-info{
          .order-doc-info{
            .content-item{
              margin-top: 16px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-size: 14px;
              line-height: 14px;
              .type{
                position: relative;
                color: #666;
                width: 55px;
                flex-shrink: 0;
                text-align-last: justify;
              }
              .info-content{
                margin-left: 25px;
                color: @black;
              }
            }
          }
          .order-type{
            .type{
              font-size: 15px;
              line-height: 15px;
              color: @black;
              font-weight: bold;
            }
            .doctor{
              margin-top: 12px;
              font-size: 14px;
              line-height: 14px;
              color: @black;
            }
          }

        }
        .unpaid{
          padding: 16px 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .unit-time{
            padding: 0 8px;
            height: 22px;
            font-size: 12px;
            line-height: 22px;
            background: #F5F5F5;
            color: @black;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .countdown{
              margin-left: 4px;
              color: @error;
            }
          }
          .pay-button{
            @button-base();
            width: 78px;
            height: 32px;
            font-size: 14px;
            background: @error;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        curentPage: 1,
        orderList: [],
        isOver: false,
        // 函数节流
        timer: null,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.getData();
    },
    mounted() {
      window.addEventListener('scroll', this.scrollToLoad);
    },
    beforeDestory() {
      window.removeEventListener('scroll', this.scrollToLoad);
    },
    methods: {
      scrollToLoad() {
        if(!this.isOver) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            let pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight);
            let viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
            let scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if(pageHeight - viewportHeight - scrollHeight < 20) {
              this.curentPage ++;
              this.getData();
            }
          }, 200);
        }
      },
      getData() {
        this.$root.post('/getOrderList', {
          user_id: this.userInfo.user_id,
          page: this.curentPage,
          count: 20,
        }).then(data => {
          this.dataDone = true;
          if(data.info && data.info.length > 0) {
            data.info.forEach(item => {
              // 将订单价格转换为正常价格
              item.money = item.money / 100;
              // 如果为待支付订单，计算剩余支付时间
              if(item.status == 1) {
                let now = parseInt(new Date().getTime() / 1000);
                item.leftTime = (item.end_time - now) * 1000;
              }
            })
          }
          this.orderList = [...this.orderList, ...data.info];
          this.isOver = data.is_over == 1 ? true : false;
          console.log(data);
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Order/list.vue